import { cn } from "~/lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowLeft,
    faArrowRight,
    faChevronDoubleLeft,
    faChevronDoubleRight,
} from "@fortawesome/pro-regular-svg-icons";
import { Tooltip } from "../Tooltip";

// // // //

export function SidebarCollapseButton(props: {
    collapsed: boolean;
    onToggle: () => void;
}) {
    const { onToggle, collapsed } = props;

    return (
        <Tooltip
            placement="right"
            tooltipContent={
                <div className="py-1 px-3 text-sm font-light flex items-center w-auto max-w-160">
                    {collapsed && (
                        <>
                            Expand Navigation
                            <FontAwesomeIcon
                                icon={faArrowRight}
                                className="w-3 ml-2"
                            />
                        </>
                    )}

                    {!collapsed && (
                        <>
                            Collapse Navigation
                            <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="w-3 ml-2"
                            />
                        </>
                    )}
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <button
                    ref={setTriggerRef}
                    className={cn(
                        "bg-muted hover:bg-background-02 rounded-sm text-sidebar-foreground hover:text-link ring-0 focus:ring-0 flex items-center justify-center border transition-colors",
                        {
                            "mt-3 w-8 h-8 min-h-8": collapsed,
                            "mt-3 absolute right-0 mr-3 w-5 h-5 min-h-5 z-300":
                                !collapsed,
                        },
                    )}
                    onClick={() => {
                        onToggle();
                    }}
                >
                    <span className="sr-only">
                        Expand or Collapse Navigation
                    </span>
                    <FontAwesomeIcon
                        className="h-3"
                        icon={
                            collapsed
                                ? faChevronDoubleRight
                                : faChevronDoubleLeft
                        }
                    />
                </button>
            )}
        </Tooltip>
    );
}
